import React from "react";

function FacebookLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M20.536 28V18.712H23.6467L24.112 15.1013H20.536V12.7973C20.536 11.752 20.8267 11.0387 22.3253 11.0387H24.2373V7.80933C23.3117 7.71113 22.3815 7.6635 21.4507 7.66667C18.6947 7.66667 16.808 9.34933 16.808 12.44V15.1013H13.6907V18.712H16.808V28H5.33333C4.97971 28 4.64057 27.8595 4.39052 27.6095C4.14048 27.3594 4 27.0203 4 26.6667V5.33333C4 4.97971 4.14048 4.64057 4.39052 4.39052C4.64057 4.14048 4.97971 4 5.33333 4H26.6667C27.0203 4 27.3594 4.14048 27.6095 4.39052C27.8595 4.64057 28 4.97971 28 5.33333V26.6667C28 27.0203 27.8595 27.3594 27.6095 27.6095C27.3594 27.8595 27.0203 28 26.6667 28H20.536Z"
        fill="#0E0E0E"
      />
    </svg>
  );
}
export default FacebookLogo;
